const root = {
    lineHeight: 'normal',
    boxShadow: 'none',

    '&:hover': {
        boxShadow: 'none',
    },

    '&:disabled': {
        pointerEvent: 'none',
        //opacity: 0.65,
    },

    /*'&:active, &:active:focus, &:active:hover': {
        opacity: 0.85,
    },*/
};

export default root;
